import { useState, cloneElement } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { classNames } from '../../utils/classNames';
import {
    extraNavigation,
} from '../../utils/navigation-constants/navigation-partner';
// import Button from '../../shared/button';
import ThemeToggle from '../../shared/theme-toggle';
import { useTheme } from '../../utils/theme-context';
import { useTopicsListQuery } from '../../store/chatbox/chatboxApi';
import { userAPI } from '../../store/user/userApi';
import { useDispatch } from 'react-redux';
import Cookies from 'js-cookie';

interface INavigation {
    search?: string
    closeSidebar?: () => void
}

const Navigation = ({
    search,
    closeSidebar
}: INavigation) => {
	const { data } = useTopicsListQuery();
    const { theme } = useTheme();
    const navigate = useNavigate();
    const [activeRoute] = useState<string>()
    const [navigationPartnerExtra] = useState<any>(extraNavigation)
    const [loading] = useState<boolean>(false)

	const dispatch = useDispatch();

    // const onClickNewChat = () => {
    //     closeSidebar?.()
    //     navigate('/home?newChat=true')
    // }

    const handleLogout = () => {
        Cookies.remove('accessToken');
        Cookies.remove('refreshToken');
        Cookies.remove('roles');
        Cookies.remove('user');
        // window.location.reload();
        // (window as any).Intercom('shutdown');
        navigate('/login');
		dispatch(userAPI.util.resetApiState());
		
    }

    const onClickPage = () => {
        navigate('/settings')
    }

    return (
        <div className='flex flex-col min-h-[85vh] justify-between '>

            <>
                <div className='h-[68vh] md:h-[72vh] overflow-y-auto mb-8'>
                    <p className='mb-3 text-[#8a8a8e] text-[13px]'>History</p>

					{data?.data.elements.map(chat => (
						<NavLink
							key={chat._id}
							className='w-full mb-2 flex flex-row items-center border border-gray-100 dark:border-primary-darkMode text-gray-900 dark: text-sm p-2 hover:opacity-80'
							to={`/staff/chat/${chat.tripId}?topicId=${chat._id}`}
						>
							<img alt='chat' className='mr-2 object-contain w-[20px]' src={theme === 'dark' ? '/svg/icons/chat-icon-white.svg' : '/svg/icons/chat.svg'} />
							<span className='dark:text-primary-darkMode'>{chat.name} {chat.inputFields?.cabinId && ' - ' + chat.inputFields?.cabinId} </span>
						</NavLink>
					))}
                    {/* <Button
                        label={'New chat'}
                        onClickButton={onClickNewChat}
                        className='btn-primary-rounded w-full flex flex-row justify-center items-center !text-normal !py-3 mb-5'
                        icon={<img src={'/assets/chat/add-white.svg'} className='object-contain mr-2 w-[20px]' />}
                    /> */}
                    {/* {historyChats && historyChats.data?.length > 0 && historyChats.data?.map(item => (
                        <NavLink
                            key={item._id}
                            onClick={closeSidebar}
                            className='w-full mb-2 flex flex-row items-center border border-gray-100 dark:border-primary-darkMode text-gray-900 text-sm p-2 cursor-pointer'
                            to={`/chat/${item._id}`}
                        >
                            <img alt='chat' className='mr-2 object-contain w-[20px]' src={theme === 'dark' ? '/svg/icons/chat-icon-white.svg' :'/svg/icons/chat.svg'} />
                            <p className='truncate dark:text-primary-darkMode'>{item?.name}</p>
                        </NavLink>
                    )
                    )} */}
                </div>
                <div className='mb-1 border-t-[1px] pt-2'>
                    <p className='mb-3 text-[#8a8a8e] text-[13px]'>Profile</p>
                    <div className='my-4 sm:my-5'>
                        <ThemeToggle />
                    </div>
                    {!loading && navigationPartnerExtra?.map((item: any) => (
                        item.href ? <NavLink
                            key={item.name}
                            to={item.href}
                            data-qa={`${(item?.name).toLowerCase().replaceAll(' ', '-')}`}
                            onClick={item.id === 'logout' ? handleLogout : closeSidebar}
                            className={({ isActive }) =>
                                classNames(
                                    'text-base text-secondary group flex items-center hover:opacity-80 px-2 py-2 font-medium rounded-md mb-2',
                                    theme === 'dark'
                                        ? '!text-primary-darkMode'
                                        : '',
                                )
                            }
                        >
                            {/* <item.icon className='mr-3 flex-shrink-0 h-6 w-6 text-indigo-300' aria-hidden='true' /> */}
                            <span className='flex mr-2 flex-shrink-0 h-6 w-6 justify-center items-center'>
                                {activeRoute === item?.href ?
                                    cloneElement(theme === 'dark' ? item.iconActive : item.icon, {
                                        width: 20,
                                        height: 20,
                                    })
                                    : cloneElement(theme === 'dark' ? item.iconActive : item.icon, {
                                        width: 20,
                                        height: 20,
                                    })
                                }
                            </span>
                            {item.name}
                        </NavLink> : <div
                            key={item.name}
                            data-qa={`${(item?.name).toLowerCase().replaceAll(' ', '-')}`}
                            onClick={item.id === 'logout' ? handleLogout : (item.id === 'settings' ? onClickPage : closeSidebar)}
                            className={classNames(
                                    'text-base text-secondary group flex items-center hover:opacity-80 px-2 py-2 font-medium rounded-md mb-2 cursor-pointer',
                                    theme === 'dark'
                                        ? '!text-primary-darkMode'
                                        : '',
                                )
                            }
                        >
                            <span className='flex mr-2 flex-shrink-0 h-6 w-6 justify-center items-center'>
                                {cloneElement(theme === 'dark' ? item.iconActive : item.icon, {
                                        width: 20,
                                        height: 20,
                                    })}
                            </span>
                            {item.name}
                        </div>
                    ))}
                </div>
            </>

        </div>
    );
};

export default Navigation;